import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown";
import { useIsOrgOwner } from "@/hooks/organizations";
import { useCurrentUser } from "@/queries/users";
import { OrganizationMember } from "@/types/organization-member";
import { EllipsisVertical } from "lucide-react";
import ChangeMemberRole from "./ChangeMemberRole";
import DeleteMember from "./DeleteMember";
import LeaveOrganization from "./LeaveOrganization";

interface MemberActionsProps {
  organizationMember: OrganizationMember;
}

const MemberActions = ({ organizationMember }: MemberActionsProps) => {
  const isOrgOwner = useIsOrgOwner();
  const currentUser = useCurrentUser();

  if (!isOrgOwner) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="tinyIcon">
          <EllipsisVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <ChangeMemberRole organizationMember={organizationMember} />
        {organizationMember.user_id === currentUser.data?.id ? (
          <LeaveOrganization organizationMember={organizationMember} />
        ) : (
          <DeleteMember organizationMember={organizationMember} />
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MemberActions;
